import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import SingleItemRelocator from '../../inventory/relocate/SingleItemRelocator';

interface Props {
  sku: string | null;
  onClose: () => void;
  onSuccess: () => void;
}

export const RelocatorDialog: React.FC<Props> = ({ sku, onClose, onSuccess }) => (
  <Dialog open={!!sku} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ pr: 6 }}>
      <IconButton size="small" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>{sku && <SingleItemRelocator sku={sku} onSuccess={onSuccess} />}</DialogContent>
  </Dialog>
);
